import request from '@/utils/request';

export function getcode(data) {
	return request({
		url: 'user/send-code',
		method: 'post',
		data,
		isNoTVerify: true,
	});
}

export function codeLogin(data) {
	return request({
		url: 'user/sms-login',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function passwordLogin(data) {
	return request({
		url: 'user/default-login',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function getWechatOauth(data) {
	return request({
		url: 'v2/user/oauth/get-wechat-oauth',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function register(data) {
	return request({
		url: 'user/register',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function registerByPhone(data) {
	return request({
		url: 'user/register-by-phone',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function getuser() {
	return request({
		url: 'user/get-user',
		method: 'get',
	});
}

export function checkByphone(data) {
	return request({
		url: 'user/check-user-by-phone',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function resetPasswordByPhone(data) {
	return request({
		url: 'user/reset-password-by-phone',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function getfreshToken(data) {
	return request({
		url: '/oauth/refresh-token',
		method: 'post',
		data,
	});
}

export function getOrderLogistics(data) {
	return request({
		url: '/v2/user/get-order-logistics',
		method: 'post',
		data,
		// isNoTVerify: true,
	});
}

export function onekeylogin(data) {
	return request({
		url: 'user/one-key-login',
		method: 'post',
		data: data,
	});
}

export function WechatLogin(data) {
	return request({
		url: '/user/wechat-login',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}

export function bindWechat(data) {
	return request({
		url: 'user/bind-wechat',
		method: 'post',
		data: data,
	});
}

export function setTel(data) {
	return request({
		url: 'user/set-tel',
		method: 'post',
		data: data,
		isNoTVerify: true,
	});
}
